export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  ASSIGNMENT_V2: 'assignment_v2',
  ASSIGN_TEAM_ON_RESOLUTION: 'assign_team_on_resolution',
  AUTO_ASSIGN_TEAM_FROM_ASSIGNEE: 'auto_assign_team_from_assignee',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTO_PENDING_ON_TEAM_CHANGE: 'auto_pending_on_team_change',
  AUTOMATIONS: 'automations',
  BROWSER_PHONE_NATIVE: 'browser_phone_native',
  CAMPAIGNS: 'campaigns',
  WHATSAPP_CAMPAIGNS: 'whatsapp_campaign',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  INTERNAL_CHAT: 'internal_chat',
  INTERNAL_CHAT_CALLS: 'internal_chat_calls',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INSERT_ARTICLE_IN_REPLY: 'insert_article_in_reply',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  RESPONSE_BOT: 'response_bot',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_TWITTER: 'channel_twitter',
  CHANNEL_WEBSITE: 'channel_website',
  CHANNEL_INSTAGRAM: 'channel_instagram',
  CHANNEL_TIKTOK: 'channel_tiktok',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  CHAT_CALLS: 'chat_calls',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  CAPTAIN: 'captain_integration',
  CAPTAIN_V2: 'captain_integration_v2',
  CAPTAIN_TASKS: 'captain_tasks',
  CUSTOM_ROLES: 'custom_roles',
  WAVOIP: 'wavoip',
  EVOLUTION_API: 'evolution_api',
  QUEPASA_API: 'quepasa_api',
  KANBAN: 'kanban',
  TYPEBOT: 'typebot',
  SCHEDULING_MESSAGES: 'scheduling_messages',
  CHATWOOT_V4: 'chatwoot_v4',
  REPORT_V4: 'report_v4',
  REMOVE_CONVERSATION_PARTICIPANTS: 'remove_conversation_participants',
  CONTACT_CHATWOOT_SUPPORT_TEAM: 'contact_chatwoot_support_team',
  SAML: 'saml',
  QUOTED_EMAIL_REPLY: 'quoted_email_reply',
  COMPANIES: 'companies',
  ADVANCED_SEARCH: 'advanced_search',
  CONVERSATION_REQUIRED_ATTRIBUTES: 'conversation_required_attributes',
};

export const PREMIUM_FEATURES = [
  FEATURE_FLAGS.SLA,
  FEATURE_FLAGS.CAPTAIN,
  FEATURE_FLAGS.CUSTOM_ROLES,
  FEATURE_FLAGS.AUDIT_LOGS,
  FEATURE_FLAGS.HELP_CENTER,
  FEATURE_FLAGS.SAML,
  FEATURE_FLAGS.CONVERSATION_REQUIRED_ATTRIBUTES,
];

export const SCHEDULE_MESSAGES = 'schedule_messages';
